const LoginStore = require('../stores/LoginStore');

const getRecaptchaToken = (callback) => {
    const appState = LoginStore.getState();
    if (appState.captchaSettings.enabled) {
        grecaptcha.enterprise.ready(() => {
            grecaptcha.enterprise.execute(appState.captchaSettings.siteKey, {action: 'submit'})
                    .then((token) => callback(token))
            }
        );
    } else {
        callback();
    }
}

const attachRecaptchaScript = (clientId, realmId) =>
    LoginStore.getCaptchaConfig(clientId, realmId, (result) => {
        if (result.enabled) {
            const captchaScript = document.createElement("script");
            captchaScript.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=${result.siteKey}`;
            document.head.appendChild(captchaScript);
        }
    })

module.exports = { getRecaptchaToken, attachRecaptchaScript };